import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { setProjectState, setTempState } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';
import expendIcon from '../../../assets/expend.svg';
import uploadIcon from '../../../assets/upload.svg';
import BookIcon from '../../../assets/book.svg';
import UploadWrapper from '../../UploadWrapper';

const ShortHeader = React.memo(() => {
  const [isOpen, setIsOpen] = useState(false);
  const openPresetModal = (e) => {
    e.stopPropagation();
    setTempState({ exclusiveWindow: 'preset-flow' });
    setIsOpen(false);
  };

  const closePreset = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    window.addEventListener('click', closePreset);
    return () => {
      window.removeEventListener('click', closePreset);
    };
  }, []);

  return (
    <div className="w-full flex items-center justify-between px-3 py-2 border-b border-[#EDEDED]">
      <div className="w-[90px] h-full text-[#2d2d2d] text-center flex items-center justify-center">
        <span className="mr-1">{translate('flow_g_flow')}</span>
        <span>
          <img
            src={expendIcon}
            alt="expend"
            className="w-[16px] h-[16px] cursor-pointer"
            onClick={() => setProjectState({ isFoldFlow: false })}
          />
        </span>
      </div>
      <div className="flex">
        <Tooltip
          open={isOpen}
          trigger="click"
          placement="topLeft"
          overlayInnerStyle={{ padding: 0, borderRadius: '2px', backgroundColor: '#282828' }}
          title={<UploadWrapper setIsOpen={setIsOpen} />}
          arrow={false}
        >
          <img
            src={uploadIcon}
            alt="open"
            className="w-[16px] h-[16px] cursor-pointer"
            onClick={(e) => (e.stopPropagation(), setIsOpen(true))}
          />
        </Tooltip>
        <img
          src={BookIcon}
          alt="upload"
          className="w-[16px] h-[16px] cursor-pointer ml-1"
          onClick={(e) => openPresetModal(e)}
        />
      </div>
    </div>
  );
});

export default ShortHeader;
